// @ts-nocheck
import type { FC, ReactNode } from "react"
import { createContext } from "react"

export interface SelectItemType {
  id: string
  label?: string
  avatarUrl?: string
  isDisabled?: boolean
  supportingText?: string
  icon?: FC | ReactNode
}

export const SelectContext = createContext<{ size: "sm" | "md" }>({
  size: "sm",
})
